<script setup lang="ts">
/**
 * AuthErrorScreen — 「認證錯誤」全屏提示。
 *
 * 對應 authStore 的 `error`（= useAuth 的 `authError`），兩種來源：
 *   1. 進站時 login / ticketLogin 就失敗（憑證無效、缺 ticket）
 *   2. 其他 API 收 401 後，重新登入重試 N 次仍失敗 → onTerminalFail → invalidate()
 *
 * 換言之走到這頁 = **已經救不回來**（中途能救回的 401 只會閃一下 retry toast，
 * 不會進到這裡）。詳見 src/composables/useTokenRetry.ts。
 *
 * 與 `PageErrorScreen` 的分工：那頁是遊戲路徑問題，本頁是身分問題。
 *
 * 純展示元件：只吃一個 message，不自己讀 store。
 */
defineProps<{
  /** 要顯示的錯誤訊息（來源 = authStore.error） */
  message: string
}>()
</script>

<template>
  <section class="relative z-10 grid h-full place-items-center p-6">
    <div class="flex flex-col items-center gap-5 text-center">
      <div class="text-amber-300/90">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" />
          <path d="M12 7v6M12 16v1" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
      </div>
      <p class="m-0 text-base leading-relaxed text-white/85">{{ message }}</p>
    </div>
  </section>
</template>
